const all_blogs_obj = {
  setActive: function (ind) {
    const active_blog_article = document.querySelector(
      ".all_blogs_wrapper .blog_articles.active"
    );
    if (active_blog_article) {
      active_blog_article.classList.remove("active");
    }
    document
      .querySelector(`.all_blogs_wrapper .blog_article__${ind}`)
      .classList.add("active");
  },
  registerEvents: function () {
    document
      .querySelectorAll(".all_blogs_wrapper .blog-button")
      .forEach((blog_button) => {
        blog_button.addEventListener("click", function () {
          if (this.parentNode.querySelector(".active"))
            this.parentNode.querySelector(".active").classList.remove("active");
          this.classList.add("active");
          all_blogs_obj.setActive(this.dataset.index);

          history.replaceState(
            {},
            "",
            `/pages/alle-blogs/${this.dataset.handle}`
          );
          if (window?.page_count) {
            window.page_count = 2;
          }
        });
      });
  },
};

all_blogs_obj.registerEvents();
